
const JS_CLASS = 'js-donation-tiers';
const elements = document.getElementsByClassName(`${ JS_CLASS }`);

// Lazy load only when needed
if (elements.length) {
  import('./donation-tiers').then(({init}) => {
    for (let collection of elements) {
      init(collection, JS_CLASS);
    }
  })
}
